import { FC } from "react";
import { ReactComponent as FlowersIcon } from "./FlowersNote.svg";
import style from "../ImportantInformation.module.scss";

export const FlowersNote: FC = () => {
  return (
    <li data-animation-direction="from-bottom" data-animation-delay="300">
      <div className="neela-style">
        <span className="h-lines"></span>
        <span className="v-lines"></span>
        <div className={style.cardTitle}>
          <span className={style.cardIcon}>
            <FlowersIcon style={{ width: 60 }} />
          </span>
          <h3>Flowers note</h3>
        </div>

        <div className="info">
          <p className={style.cardText}>
            We have a small request: instead of flowers, we would be delighted
            if you brought a bottle of your favorite still or sparkling wine.
            This thoughtful gesture will become a cherished part of our
            celebration and remind us of each one of you.
          </p>
          <p className={style.cardText}>
            But if flowers are your thing and you really want to bring them, no
            worries! Just reach out to Alina, and she’ll help you pick a bouquet
            that matches our wedding vibe perfectly.
          </p>
          <a
            href="https://www.instagram.com/alma_flower_service"
            className="btn btn-primary reverse"
            target="_blank"
            rel="noreferrer"
          >
            <span className="h-lines"></span>
            <span className="v-lines"></span>
            <i className="fab fa-instagram"></i>Contact Alina
          </a>
        </div>
      </div>
    </li>
  );
};
